import React from "react";
import { Navigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";

export default function ProtectedRoute({ children }) {
  const { user, loading } = useAuth();
  if (loading || user === null) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-[#0a0a0a]">
        <div className="text-[#a3a3a3] text-sm tracking-[0.2em] uppercase">Loading</div>
      </div>
    );
  }
  if (!user) return <Navigate to="/login" replace />;
  return children;
}
